export default {
  namespaced: true,
  state: {
    count: 0,
  },

  getters: {
    spinning: (state) => state.count > 0,
  },

  mutations: {
    work(state, delta) {
      state.count += delta
    },
  },
}
